import type { DatasetPlanPositioningProps } from "./dataset-plan-positioning.type";

import DatasetPlanPositioningCard from "./dataset-plan-positioning-card";
import DatasetPlanPositioningEditor from "./dataset-plan-positioning-editor";
import DatasetPlanPositioningProvider from "./dataset-plan-positioning.provider";

import "./dataset-plan-positioning.style.less";

const DatasetPlanPositioning = (props: DatasetPlanPositioningProps) => {
  return (
    <div className="dataset-plan-positioning">
      <DatasetPlanPositioningProvider {...props}>
        <DatasetPlanPositioningCard>
          <DatasetPlanPositioningEditor />
        </DatasetPlanPositioningCard>
      </DatasetPlanPositioningProvider>
    </div>
  );
};

export default DatasetPlanPositioning;
